import { PATHS } from "../constants/paths"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Container, Link } from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { NavLink } from "react-router-dom"
import React, { useState } from "react"
import { SEO } from "../components/SEO"

export const Faqs = () => {
  const [expanded, setExpanded] = useState(false)

  // Возвращает колбэк для onChange каждой конкретной панели
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Box>
      <SEO
        title="Zombie TD | FAQ - Everything You Need to Know"
        description="Find answers to common questions about Zombie TD, FCD, NFTs, staking, and more."
        ogTitle="Zombie TD | FAQ"
        ogDescription="Get answers to all your questions about Zombie TD and its features."
        ogUrl="/faq."
      />
      <div className="content content-faqs">
        <Box className="content-head">
          <Container fixed>
            <Typography variant={"h1"} mb={2}>
              FAQ
            </Typography>
          </Container>
        </Box>
        <Box
          className="content-body"
          sx={{
            "& h5.MuiTypography-root": {
              fontSize: {
                xs: 12,
                sm: 14,
              },
              letterSpacing: ".325px",
            },
            "& p.MuiTypography-root": {
              color: "#ccc",
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              margin: "16px 0 0",
            },
          }}
        >
          <Container fixed>
            <Typography variant={"h5"} mb={4}>
              FCD & Token Sale
            </Typography>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className="faq-question">
                  What is FCD and how can I participate?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  FCD (Fair Community Distribution) is a public token sale with
                  no whitelists, no private rounds, and no investor allocations.
                  It allows anyone to buy tokens under the same conditions.
                  <br />
                  <br />
                  <span className="primary">How to participate:</span>
                  <Stack spacing={1} sx={{ pl: 5 }}>
                    <ul className="customList">
                      <li>
                        The official wallet address for participation will be
                        published on the website and social media
                      </li>
                      <li>FCD consists of 3 rounds, each lasting 24 hours.</li>
                      <li>
                        In each round, participants send USDT to the displayed
                        address.
                      </li>
                      <li>
                        After the round ends, tokens are distributed strictly in
                        proportion to each participant’s contribution.
                      </li>
                    </ul>
                  </Stack>
                  <br />
                  <br />
                  <span className="primary">Token distribution:</span>
                  <Stack spacing={1} sx={{ pl: 5 }}>
                    <ul className="customList">
                      <li>
                        3% of the total token supply (30 million ZTD) is
                        allocated per round.
                      </li>
                      <li>
                        The token price for each round is calculated as:
                        <br />
                        <span className="primary">
                          <i>
                            Total USDT received in the round ÷ 30,000,000 ZTD
                            (3% of supply).
                          </i>
                        </span>
                      </li>
                    </ul>
                  </Stack>
                  <br />
                  <br />
                  There is a minimum deposit of 10 USDT, but no maximum limit —
                  you can invest as much as you want. No identity verification
                  (KYC) is needed to join.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  When will the token be listed?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  There is no exact listing date yet.
                  <br />
                  The listing will take place after the launch of NFT Box sales.
                  <br />
                  We will announce the official date on our social media
                  channels — follow us to stay updated with all key
                  announcements.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  When will I receive my tokens?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  You will be able to claim 50% of your allocated tokens at the
                  Token Generation Event (TGE). The remaining 50% will be
                  unlocked gradually over a 2-month linear vesting period —
                  without any cliff or delay.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  Is there a Referral Program during FCD?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography gutterBottom>
                  <Stack spacing={1} sx={{ pl: 5 }}>
                    <ul className="customList">
                      <li>Round 1: 8%</li>
                      <li>Round 2: 10%</li>
                      <li>Round 3: 12%</li>
                    </ul>
                  </Stack>
                  <br />
                  Rewards are instantly withdrawable after each round.
                  <br />
                  Additionally, the Referral Program is also active during the
                  sale of NFT Boxes with Commanders and Turrets, where you earn
                  15% of the purchase amount through your referral link.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  Can I cancel or get a refund for the funds sent during the
                  FCD?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  No, all transactions are final and irreversible. USDT sent
                  during the FCD cannot be refunded.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <br />
            <br />
            <br />
            <br />

            <Typography variant={"h5"} mb={4}>
              Earning & Rewards
            </Typography>
            <Accordion
              expanded={expanded === "panel6"}
              onChange={handleChange("panel6")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  How do I earn in the project?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Zombie TD offers many earning methods:
                  <Stack spacing={1} sx={{ pl: 5 }}>
                    <ul className="customList">
                      <li>
                        Campaign Mode (PvE): Complete missions and levels to
                        earn in-game rewards.
                      </li>
                      <li>
                        PvP and Leaderboard Tournaments: Compete against other
                        players for top ranks and win valuable prizes.
                      </li>
                      <li>
                        Endless Mode with Weekly Rewards: Survive as long as
                        possible to earn weekly bonuses based on your
                        performance.
                      </li>
                      <li>
                        Staking (ZTD Tokens & NFTs): Lock your ZTD tokens and
                        NFTs to earn passive income through staking rewards.
                      </li>
                      <li>
                        Monthly Airdrops for NFT Holders: Hold special NFTs to
                        qualify for exclusive monthly airdrops and giveaways.
                      </li>
                      <li>
                        Zealy Quests & Referral Programs: Complete quests and
                        invite friends to earn extra rewards and USDT bonuses.
                      </li>
                      <li>
                        NFT and Token Trading: Buy, sell, and trade NFTs and
                        tokens on supported marketplaces to profit from market
                        movements.
                      </li>
                      <li>
                        Investing in ZTD during FCD: Participate early by
                        investing in ZTD tokens during the FCD phase to maximize
                        potential returns.
                      </li>
                    </ul>
                  </Stack>
                  <br />
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel7"}
              onChange={handleChange("panel7")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  How can I earn rewards through the Referral Program?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  You can earn USDT rewards by sharing your referral link during
                  the FCD and NFT box sales. For each purchase made via your
                  link, you receive:
                  <Stack spacing={1} sx={{ pl: 5 }}>
                    <ul className="customList">
                      <li>
                        FCD Referral Program:
                        <ul className="customList">
                          <li>Round 1: 8%</li>
                          <li>Round 2: 10%</li>
                          <li>Round 3: 12%</li>
                        </ul>
                        Rewards are withdrawable immediately after each round.
                      </li>
                      <li>
                        NFT Box Sales Referral Program:
                        <ul className="customList">
                          <li>
                            Earn 15% of the purchase amount when your referrals
                            buy NFT Boxes with Commanders and Turrets.
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <br />
                    This is a great way to boost your earnings while supporting
                    the project!
                  </Stack>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel8"}
              onChange={handleChange("panel8")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  How can I avoid scams?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Always use official links and wallets listed on the website
                  and social media channels. The project does not conduct token
                  sales via private messages.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <br />
            <br />
            <br />
            <br />

            <Typography variant={"h5"} mb={4}>
              Gameplay & Access
            </Typography>
            <Accordion
              expanded={expanded === "panel9"}
              onChange={handleChange("panel9")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  What kind of game is Zombie TD?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Zombie TD is a browser-based Web3 tower defense game set in a
                  post-apocalyptic world. Players build strategic defenses using
                  NFT turrets and commanders to fight endless zombie waves.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel10"}
              onChange={handleChange("panel10")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  Do I need to install anything?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  No. The game runs in any modern browser — no downloads or app
                  store required. Zombie TD game works on desktop, tablet, and
                  mobile browsers.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel11"}
              onChange={handleChange("panel11")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  What do I need to start playing?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  You need a BEP-20 compatible wallet connected to the BNB Smart
                  Chain network (such as MetaMask, Trust Wallet, or any other
                  supported wallet). Additionally, you must have at least 1 NFT
                  Turret to participate in the game.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel12"}
              onChange={handleChange("panel12")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <Typography className="faq-question">
                  Can I play for free?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Unfortunately, no. You need to have at least 1 NFT Turret of
                  any type to enter battles, as these NFTs are what shoot and
                  kill monsters in the game.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Container>
        </Box>
      </div>
    </Box>
  )
}
